function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license
 * Copyright (c) 2017 - 2023 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */
import { AriaModalController } from '@vaadin/a11y-base/src/aria-modal-controller.js';
import { FocusRestorationController } from '@vaadin/a11y-base/src/focus-restoration-controller.js';
import { FocusTrapController } from '@vaadin/a11y-base/src/focus-trap-controller.js';
import { getDeepActiveElement } from '@vaadin/a11y-base/src/focus-utils.js';
import { ControllerMixin } from '@vaadin/component-base/src/controller-mixin.js';
/**
 * @polymerMixin
 * @mixes ControllerMixin
 */

export var OverlayFocusMixin = function OverlayFocusMixin(superClass) {
  return /*#__PURE__*/function (_ControllerMixin) {
    _inherits(OverlayFocusMixin, _ControllerMixin);

    var _super = _createSuper(OverlayFocusMixin);

    function OverlayFocusMixin() {
      var _this;

      _classCallCheck(this, OverlayFocusMixin);

      _this = _super.call(this);
      _this.__ariaModalController = new AriaModalController(_assertThisInitialized(_this));
      _this.__focusTrapController = new FocusTrapController(_assertThisInitialized(_this));
      _this.__focusRestorationController = new FocusRestorationController();
      return _this;
    }
    /** @protected */


    _createClass(OverlayFocusMixin, [{
      key: "ready",
      value: function ready() {
        _get(_getPrototypeOf(OverlayFocusMixin.prototype), "ready", this).call(this);

        this.addController(this.__ariaModalController);
        this.addController(this.__focusTrapController);
        this.addController(this.__focusRestorationController);
      }
      /**
       * Release focus and restore focus after the overlay is closed.
       *
       * @protected
       */

    }, {
      key: "_resetFocus",
      value: function _resetFocus() {
        if (this.focusTrap) {
          this.__ariaModalController.close();

          this.__focusTrapController.releaseFocus();
        }

        if (this.restoreFocusOnClose && this._shouldRestoreFocus()) {
          this.__focusRestorationController.restoreFocus();
        }
      }
      /**
       * Save the previously focused node when the overlay starts to open.
       *
       * @protected
       */

    }, {
      key: "_saveFocus",
      value: function _saveFocus() {
        if (this.restoreFocusOnClose) {
          this.__focusRestorationController.saveFocus(this.restoreFocusNode);
        }
      }
      /**
       * Trap focus within the overlay after opening has completed.
       *
       * @protected
       */

    }, {
      key: "_trapFocus",
      value: function _trapFocus() {
        if (this.focusTrap) {
          this.__ariaModalController.showModal();

          this.__focusTrapController.trapFocus(this.$.overlay);
        }
      }
      /**
       * Returns true if focus is still inside the overlay or on the body element,
       * otherwise false.
       *
       * Focus shouldn't be restored if it's been moved elsewhere by another
       * component or as a result of a user interaction e.g. the user clicked
       * on a button outside the overlay while the overlay was open.
       *
       * @protected
       * @return {boolean}
       */

    }, {
      key: "_shouldRestoreFocus",
      value: function _shouldRestoreFocus() {
        var activeElement = getDeepActiveElement();
        return activeElement === document.body || this._deepContains(activeElement);
      }
      /**
       * Returns true if the overlay contains the given node,
       * including those within shadow DOM trees.
       *
       * @param {Node} node
       * @return {boolean}
       * @protected
       */

    }, {
      key: "_deepContains",
      value: function _deepContains(node) {
        if (this.contains(node)) {
          return true;
        }

        var n = node;
        var doc = node.ownerDocument; // Walk from node to `this` or `document`

        while (n && n !== doc && n !== this) {
          n = n.parentNode || n.host;
        }

        return n === this;
      }
    }], [{
      key: "properties",
      get: function get() {
        return {
          /**
           * When true, opening the overlay moves focus to the first focusable child,
           * or to the overlay part with tabindex if there are no focusable children.
           * @attr {boolean} focus-trap
           */
          focusTrap: {
            type: Boolean,
            value: false
          },

          /**
           * Set to true to enable restoring of focus when overlay is closed.
           * @attr {boolean} restore-focus-on-close
           */
          restoreFocusOnClose: {
            type: Boolean,
            value: false
          },

          /**
           * Set to specify the element which should be focused on overlay close,
           * if `restoreFocusOnClose` is set to true.
           * @type {HTMLElement}
           */
          restoreFocusNode: {
            type: HTMLElement
          }
        };
      }
    }]);

    return OverlayFocusMixin;
  }(ControllerMixin(superClass));
};